import { render } from "./YouTube.vue?vue&type=template&id=544ea0b6"
const script = {}
script.render = render

export default script